















































































































import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import { date } from 'quasar'
import DeadlineTimer from 'components/DeadlineTimer.vue'
import confirm from 'components/modals/Confirm'
import alert from 'components/modals/Alert'
import DateTime from 'components/modals/DateTime.vue'
import { Session, ItemTypeTopic } from 'src/graphql/types'

@Component({
  components: {
    DeadlineTimer,
    DateTime
  }
})
export default class SessionManagerController extends Vue {
  ItemTypeTopic = ItemTypeTopic
  formatDate = date.formatDate

  @Prop()
  readonly slides!: Json[]

  @Prop()
  readonly session!: Session

  @Ref()
  readonly startSchedule!: DateTime

  @Ref()
  readonly stopSchedule!: DateTime

  async startNow () {
    await confirm({ title: this.$t('sessions.manager.confirm.start').toString() })
    this.$emit('save', { startedAt: new Date() })
  }

  async startScheduleSet (startedAt: string) {
    if (new Date(startedAt) > new Date())  {
      this.$emit('save', { startedAt })
    } else {
      await alert({
        title: this.$t('label.error').toString(),
        message: this.$t('sessions.manager.confirm.startError').toString()
      })
    }
  }

  startCancel () {
    this.$emit('save', { startedAt: null, stoppedAt: null })
  }

  async endNow () {
    if (this.session.startedAt) {
      if (new Date(this.session.startedAt) > new Date()) {
        this.stopSchedule.show()
      } else {
        await confirm({ title: this.$t('sessions.manager.confirm.stop').toString() })
        try {
          this.$emit('save', { stoppedAt: new Date() })
        } catch (e) {}
      }
    }
  }

  async stopScheduleSet (stoppedAt: string) {
    if (this.session.startedAt) {
      if (new Date(this.session.startedAt) < new Date(stoppedAt)) {
        try {
          this.$emit('save', { stoppedAt })
        } catch (e) {}
      } else {
        await alert({
          title: this.$t('label.error').toString(),
          message: this.$t('sessions.manager.confirm.stopError').toString()
        })
      }
    }
  }

  endCancel () {
    this.$emit('save', { stoppedAt: null })
  }
}
